import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTelevisionOld: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconTelevisionOld"><Path d="M6.90802 2.78958C7.16232 2.46262 7.63353 2.40372 7.96049 2.65802L12 5.79989L16.0396 2.65802C16.3665 2.40372 16.8377 2.46262 17.092 2.78958C17.3464 3.11654 17.2875 3.58775 16.9605 3.84205L14.186 6H19.25C20.7688 6 22 7.23122 22 8.75V18.25C22 19.7688 20.7688 21 19.25 21H4.75C3.23122 21 2 19.7688 2 18.25V8.75C2 7.23122 3.23122 6 4.75 6H9.81409L7.03958 3.84205C6.71262 3.58775 6.65372 3.11654 6.90802 2.78958Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTelevisionOld;
